import { Collapse, CollapseProps, Flex, Typography } from "antd";
import { useStores } from "stores";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";
import { CommonTable } from "components";
import { getColumns } from "./getColumns";
import { routes } from "constants/routes";

export const CompanyUserList = observer(() => {
  const { companyUsers } = useStores();
  const navigate = useNavigate();

  const collapseItem: CollapseProps["items"] = [
    {
      key: "1",
      label: (
        <Flex align="center">
          <Typography.Text strong className="whitebox-title">
            Пользователи компании
          </Typography.Text>
        </Flex>
      ),
      children: (
        <Flex vertical gap="large">
          <CommonTable
            store={companyUsers}
            columns={getColumns()}
            updateWithInterval
            onRow={(record) => ({
              onClick: () => {
                navigate(`/${routes.users}/${record.id}`);
              },
              className: "cursor-pointer",
            })}
          />
        </Flex>
      ),
    },
  ];

  return <Collapse items={collapseItem} bordered={false} expandIconPosition="end" />;
});
